module.exports = __webpack_public_path__ + "static/ugburo-84be49b6f93b594a19458e1e2791d238.png";